import axiosInstance from '../../../config/axiosInstance';
const LeadDocumentService = {
    async GetAllLeadDocuments(redirectCallback, LeadID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Lead/GetAllLeadDocuments?LeadID=${LeadID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteLeadDocument(ID, redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Lead/DeleteLeadDocument?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
};

export default LeadDocumentService;